import React from 'react';

export default function Close({color = '#222222'}: {color?: string}) {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M19 5L5 19M5 5L19 19' stroke={color} strokeWidth='2' strokeLinecap='round' />
        </svg>
    );
}
